import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { ref, watch } from 'vue';
import { developmentModules, getModuleForPath } from '@/lib/moduleRegistry';
import { locale, t } from '@/i18n';
export const navigationPending=ref(false);
let navigationTimer:ReturnType<typeof setTimeout>|undefined;
function finishNavigation(){clearTimeout(navigationTimer);navigationPending.value=false;}
export const router=createRouter({
  history:createWebHistory(),scrollBehavior:(to,from,saved)=>saved || (to.path===from.path?false:{top:0}),
  routes:[
    {path:'/',redirect:'/udra/articulos'},
    {path:'/login',component:()=>import('@/modules/auth/AuthPage.vue'),props:{mode:'login'},meta:{public:true}},
    {path:'/recuperar-acceso',component:()=>import('@/modules/auth/AuthPage.vue'),props:{mode:'recover'},meta:{public:true}},
    {path:'/restablecer-acceso',component:()=>import('@/modules/auth/AuthPage.vue'),props:{mode:'reset'},meta:{public:true}},
    {path:'/dashboard',redirect:'/dashboard/segmentacion'},
    {path:'/dashboard/segmentacion',component:()=>import('@/modules/dashboard/pages/SegmentacionPage.vue'),meta:{title:'Segmentación · Dashboard · ENAPRES'}},
    {path:'/documentos-metodologicos',component:()=>import('@/modules/documents/pages/DocumentLibraryPage.vue'),meta:{moduleId:'documentos-metodologicos',title:'Documentos metodológicos · ENAPRES'}},
    {path:'/udra/articulos',component:()=>import('@/modules/udra/pages/ArticlesPage.vue')},
    {path:'/udra/catalogos',component:()=>import('@/modules/udra/pages/CatalogsPage.vue')},
    {path:'/udra/ingresos',component:()=>import('@/modules/udra/pages/MovementsPage.vue'),props:{kind:'income'}},
    {path:'/udra/salidas',component:()=>import('@/modules/udra/pages/MovementsPage.vue'),props:{kind:'outgoing'}},
    {path:'/udra/asignaciones',component:()=>import('@/modules/udra/pages/MovementsPage.vue'),props:{kind:'assignment'}},
    {path:'/udra/asignaciones/nueva',component:()=>import('@/modules/udra/pages/AssignmentFormPage.vue')},
    ...developmentModules.map(module=>({
      path:module.path,
      name:module.id,
      component:()=>import('@/modules/platform/ModuleDevelopmentPage.vue'),
      props:{moduleId:module.id},
      meta:{moduleId:module.id,title:`${module.name} · ENAPRES`,development:true}
    })),
    {path:'/:pathMatch(.*)*',component:()=>import('@/components/NotFoundPage.vue')}
  ]
});
router.beforeEach(async to=>{
  clearTimeout(navigationTimer);
  navigationTimer=setTimeout(()=>{navigationPending.value=true;},180);
  const auth=useAuthStore();
  if(!auth.ready){try{await auth.load();}catch{if(!to.meta.public)return {path:'/login',query:{connection:'error',next:to.fullPath}};}}
  if(!to.meta.public&&!auth.user)return {path:'/login',query:{next:to.fullPath}};
  if(to.path==='/login'&&auth.user)return '/udra/articulos';
});
function updateDocumentTitle() {
  const path = router.currentRoute.value.path;
  if (path === '/dashboard/segmentacion') { document.title = `${t('shell.segmentation')} · Dashboard · ENAPRES`; return; }
  const module = getModuleForPath(path);
  if (module && module.id !== 'udra') { document.title = `${module.name} · ENAPRES`; return; }
  const key = path.includes('recuperar') ? 'recover' : path.includes('restablecer') ? 'reset' : path.includes('login') ? 'access' : path.includes('catalogos') ? 'catalogs' : path.includes('asignaciones') ? 'assignment' : path.includes('ingresos') ? 'income' : path.includes('salidas') ? 'outgoing' : 'items';
  document.title = `${t(`shell.${key}`)} · ENAPRES UDRA`;
}
router.afterEach(()=>{finishNavigation();updateDocumentTitle();});
watch(locale, updateDocumentTitle);
router.onError(finishNavigation);
